import { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";


const FileInput = ({ value, onChange, disabled, accept, clear, error, helperText, ...others }) => {
    const fileUploadRef = useRef();
    const [hover, setHover] = useState(false);

    const handleClick = (event) => {
        event.stopPropagation();
        fileUploadRef.current.click();
    };

    const handleMouseEnter = () => {
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
    };

    const handleClearClick = (event) => {
        event.stopPropagation();
        clear();
    };

    useEffect(() => {
        if (!value) fileUploadRef.current.value = null;
    }, [value]);


    return (
        <>
            <TextField
                value={value ? value?.name : ""}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                disabled={disabled}
                error={error}
                helperText={helperText}
                {...others}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <>
                                <input
                                    hidden
                                    accept={accept}
                                    type="file"
                                    onChange={(event) => onChange(event)}
                                    ref={fileUploadRef}
                                    disabled={disabled}
                                />
                                {hover && value ?
                                    <IconButton title="Limpiar" onClick={handleClearClick} sx={{ p: 0 }}>
                                        <ClearIcon color="secondary" />
                                    </IconButton>
                                    : <AttachFileIcon color={!disabled ? "primary" : "secondary"} />
                                }
                            </>
                        </InputAdornment>
                    ),
                }}
            />
        </>
    );
};


export default FileInput;